'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerLoginSuccess() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_SUCCESS + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_SUCCESS, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginSuccess;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackBookmakerLoginSuccess.js
// module id = 1765
// module chunks = 0